<template>
    <div>
        <a-action-button @click="visible = true" icon="uim:check" intent="primary"></a-action-button>

        <transition>
            <div v-if="container">
                <ProductArrivedPopup v-model:visible="visible" :item="props.item" @update="onUpdate" />
            </div>
        </transition>
    </div>
</template>

<script setup>
import { ref, watch, defineProps, inject } from 'vue';
import ProductArrivedPopup from '@/components/sourcings/ProductArrivedPopup';

const updateSourcing = inject('updateSourcing')
const visible = ref(false);
const container = ref(false);
const props = defineProps({
    item: {
        required: true
    }
})

const onUpdate = (sourcing) => {
    console.log('updating')
    updateSourcing(sourcing)
}

watch(() => visible.value, (newValue) => {

    if (!newValue) {
        setTimeout(() => container.value = false, 300)
    }

    if (newValue) {
        container.value = true
    }
});

</script>

<style></style>